import React from "react";
import { Div } from "atomize";
import { graphql } from "gatsby";

import Header from "../components/common/Header";

import SEO from "../components/seo";
import Layout from "../components/common/layout";
import Footer from "../components/common/Footer";
import ReviewModule from "../components/common/ReviewModule";
import InfluencerContentHero from "../components/influencercontent/InfluencerContentHero";
import InfluencerAttention from "../components/influencercontent/InfluencerAttention";
import InfluencerCalender from "../components/influencercontent/InfluencerCalender";
import InfluencerGenerate from "../components/influencercontent/InfluencerGenerate";
import InfluencerDashboard from "../components/influencercontent/InfluencerDashBoard";
import InfluencerUnlock from "../components/influencercontent/InfluencerUnlock";
import SolutionsFooter from "../components/common/SolutionsFooter";
import InfluencerChart from "../components/influencercontent/InfluencerChart";

const InfluencerContent = ({ data }) => {
  const content = JSON.parse(data.contentfulJson.json.json);

  return (
    <Layout>
      <SEO
        seo={data.contentfulJson.seo}
        url="https://trend.io/influencer-generated-content"
      />
      <Header headerFixed={true} data={{ contentfulJson: data.headerJson }} />
      <InfluencerContentHero
        content={content.hero}
        form={
          data.contentfulGlobalConfig.influencerGeneratedContentForm1
            .influencerGeneratedContentForm1
        }
      />
      <Div m={{ y: "6.375rem" }}>
        <InfluencerAttention content={content.influencerAttention} />
      </Div>
      <InfluencerChart content={content.influencerChart} />
      <Div m={{ t: "11rem" }}>
        <InfluencerCalender content={content.influencerCalender} />
      </Div>
      <InfluencerGenerate content={content.influencerGenerate} />
      <InfluencerDashboard content={content.influencerDashboard} />
      <Div m={{ t: "8rem" }}>
        <ReviewModule content={content.reviewModule} />
      </Div>
      <InfluencerUnlock content={content.influencerUnlock} />
      <Div m={{ t: { xs: "9.5rem", md: "12.8rem" } }}>
        <SolutionsFooter content={content.footerContent} />
      </Div>
      <Footer
        contentfulFooter={data.contentfulFooter}
        contentfulGlobalConfig={data.contentfulGlobalConfig}
      />
    </Layout>
  );
};

export const query = graphql`
  query SolutionPage5 {
    contentfulFooter(contentful_id: { eq: "5noUnCCOBDl8Is2Ppw2Nty" }) {
      solutions {
        label
        link
        isExternal
      }
      menu {
        label
        link
        isExternal
      }
      links {
        label
        link
        isExternal
      }
      instagramLink
      logoLink
    }

    contentfulGlobalConfig {
      footerForm {
        footerForm
      }
    }

    headerJson: contentfulJson(
      contentful_id: { eq: "2NCeKxLHd9JagUBAEsXDMo" }
    ) {
      json {
        json
      }
    }

    contentfulJson(contentful_id: { eq: "1jy5kAyRcCIdWTorcSQUGA" }) {
      json {
        json
      }

      seo {
        ...SeoFragment
      }
    }

    contentfulGlobalConfig {
      influencerGeneratedContentForm1 {
        influencerGeneratedContentForm1
      }
    }
  }
`;

export default InfluencerContent;
